var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegratedCommercialPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_623_1339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3486 60.5421L62.3486 77.7383C62.3486 78.4713 62.9455 79.0654 63.6819 79.0654L77.7279 79.0654C78.4642 79.0654 79.0611 78.4713 79.0611 77.7383L79.0611 60.5421C79.0611 59.8091 78.4642 59.215 77.7279 59.215L63.6819 59.215C62.9455 59.215 62.3486 59.8091 62.3486 60.5421Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3486 60.5421L62.3486 77.7383C62.3486 78.4713 62.9455 79.0654 63.6819 79.0654L77.7279 79.0654C78.4642 79.0654 79.0611 78.4713 79.0611 77.7383L79.0611 60.5421C79.0611 59.8091 78.4642 59.215 77.7279 59.215L63.6819 59.215C62.9455 59.215 62.3486 59.8091 62.3486 60.5421Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3486 10.2618L62.3486 27.4581C62.3486 28.191 62.9455 28.7852 63.6819 28.7852L77.7279 28.7852C78.4642 28.7852 79.0611 28.191 79.0611 27.4581L79.0611 10.2618C79.0611 9.52885 78.4642 8.93468 77.7279 8.93468L63.6819 8.93468C62.9455 8.93468 62.3486 9.52885 62.3486 10.2618Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3486 10.2618L62.3486 27.4581C62.3486 28.191 62.9455 28.7852 63.6819 28.7852L77.7279 28.7852C78.4642 28.7852 79.0611 28.191 79.0611 27.4581L79.0611 10.2618C79.0611 9.52885 78.4642 8.93468 77.7279 8.93468L63.6819 8.93468C62.9455 8.93468 62.3486 9.52885 62.3486 10.2618Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4258 36.2803L34.4258 53.4766C34.4258 54.2095 35.0227 54.8037 35.759 54.8037L49.805 54.8037C50.5414 54.8037 51.1383 54.2095 51.1383 53.4766L51.1383 36.2803C51.1383 35.5474 50.5414 34.9532 49.805 34.9532L35.759 34.9532C35.0227 34.9532 34.4258 35.5474 34.4258 36.2803Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4258 36.2803L34.4258 53.4766C34.4258 54.2095 35.0227 54.8037 35.759 54.8037L49.805 54.8037C50.5414 54.8037 51.1383 54.2095 51.1383 53.4766L51.1383 36.2803C51.1383 35.5474 50.5414 34.9532 49.805 34.9532L35.759 34.9532C35.0227 34.9532 34.4258 35.5474 34.4258 36.2803Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 69L46.4973 69C44.6355 69 43.1044 67.3832 43.1044 65.4173L43 55",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 19L46.232 19C44.4586 19 43 20.7046 43 22.7772L43 35",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3486 35.4014L62.3486 52.5977C62.3486 53.3306 62.9455 53.9248 63.6819 53.9248L77.7279 53.9248C78.4642 53.9248 79.0611 53.3306 79.0611 52.5977L79.0611 35.4014C79.0611 34.6685 78.4642 34.0743 77.7279 34.0743L63.6819 34.0743C62.9455 34.0743 62.3486 34.6685 62.3486 35.4014Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3486 35.4014L62.3486 52.5977C62.3486 53.3306 62.9455 53.9248 63.6819 53.9248L77.7279 53.9248C78.4642 53.9248 79.0611 53.3306 79.0611 52.5977L79.0611 35.4014C79.0611 34.6685 78.4642 34.0743 77.7279 34.0743L63.6819 34.0743C62.9455 34.0743 62.3486 34.6685 62.3486 35.4014Z",
    stroke: "#0091C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3486 44.3555L51.2695 44.3555",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7852 22.6172L61.7849 19.0845",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7852 15.5523L61.7849 19.085",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.917 47.8877L61.898 44.355",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.917 40.8228L61.898 44.3555",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 45L26 45",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8809 48.6357L33.8618 45.103",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8809 41.5708L33.8618 45.1035",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.917 72.5791L61.898 69.0464",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.917 65.5142L61.898 69.0469",
    stroke: "#0091C4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 45,
    r: 8.25,
    stroke: "#0091C4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 45,
    r: 3.25,
    stroke: "#0091C4",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_623_1339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(8 80) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegratedCommercialPlanning);
export default __webpack_public_path__ + "static/media/integrated-commercial-planning.09b1d32c68f0d10233bec6db0b6d8473.svg";
export { ForwardRef as ReactComponent };